import { orderIdZodSchema } from "@@/shared/orders/order-id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { userIdZodSchema } from "@@/shared/users/user-id";
import z from "zod";

const messageReferencesZodObject = z.object({
    orderId: orderIdZodSchema,
    providerId: providerIdZodSchema.nullish(), // providerId is optional
    customerId: userIdZodSchema.nullish(), // customerId is optional
});
type MessageReferences = z.infer<typeof messageReferencesZodObject>;

export { messageReferencesZodObject };
export type { MessageReferences };
